import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ROUTES_NAME } from '../models/routes-name';
import { ConsumableService } from '../services/consumable.service';
import { ToastType } from '../shared/modals/models/toast';
import { MessageHandler } from '../shared/modals/services/message-handler.service';

/**
 * Il configuratore si apre solo con accountId e opportunityId nella rotta: se ne manca uno si
 * torna alla home, prima ancora di chiamare Sugar (che è compito del {@link sugarContextResolver}).
 */
export const sugarContextGuard: CanActivateFn = (route) => {
	const missingFields = [
		{ label: 'NEW_QUOTATION_PAGE.CUSTOMER_REGISTRY', id: route.queryParamMap.get('accountId') },
		{ label: 'NEW_QUOTATION_PAGE.OPPORTUNITY', id: route.queryParamMap.get('opportunityId') },
	].filter((field) => !field.id);

	if (!missingFields.length) {
		return true;
	}

	const consumableService = inject(ConsumableService);
	const routerService = inject(Router);
	const messageHandler = inject(MessageHandler);
	const translateService = inject(TranslateService);
	//scarta l'eventuale offerta da duplicare: il configuratore non viene creato e non la consuma,
	//e la prossima nuova offerta si aprirebbe precompilata con quella
	//(es. Duplica su un'offerta senza Anagrafica/Opportunità → torno in home → Procedi
	//apre il configuratore con i dati dell'offerta duplicata)
	consumableService.clear();
	//capita con un URL incompleto o duplicando un'offerta salvata prima del collegamento a Sugar.
	const message = translateService.instant('NEW_QUOTATION_PAGE.CONTEXT_ERROR_MISSING', {
		fields: missingFields.map((field) => translateService.instant(field.label)).join(', '),
	});
	messageHandler.showToast(ToastType.ERROR_TOAST, undefined, message);
	return routerService.createUrlTree([ROUTES_NAME.HOME]);
};
